import { findAddressforGeolocation } from '../../../dataSource/address/address.request'

export const findAddressFromPoint = payload =>
  findAddressforGeolocation(payload).then(({ addresses }) => {
    if (addresses.length < 1) return Promise.reject(new Error('No address found at this point !'))
    return addresses[0]
  })
